<form [formGroup]="eventForm" class="cw-submodule">
    <!-- Modul-Titel -->
    <h3>Daten</h3>
    <div class="cw-horizontalline"></div>

    <!-- Maßnahme -->
    <phscw-input-select
        [editMode]="editMode"
        label="Maßnahme"
        name="event_type"
        inputId="event_type"
        formControlName="event_type"
        listentries="eventType"
        [getListData]="true">
    </phscw-input-select>

    <!-- <phscw-input-select
        [editMode]="editMode"
        label="Investition"
        name="event_subtype"
        inputId="event_subtype"
        formControlName="event_subtype"
        listentries="eventSubtype"
        [getListData]="true">
    </phscw-input-select> -->

    <!-- Status -->
    <phscw-input-select
        [editMode]="editMode"
        label="Status"
        name="event_status"
        inputId="event_status"
        formControlName="event_status"
        listentries="eventStatus"
        [getListData]="true">
    </phscw-input-select>

    <!-- Aktionsstart (Pflichtfeld – schaltet Aktionsende frei) -->
    <phscw-input-date
        formControlName="event_start_date"
        [editMode]="editMode"
        name="event_start_date"
        inputId="event_start_date"
        label="Aktionsstart"
        [required]="true">
    </phscw-input-date>
    @if (editMode && eventForm.get('event_start_date')?.invalid && eventForm.get('event_start_date')?.touched) {
        <span class="cw-input-hint">Bitte einen Aktionsstart angeben.</span>
    }

    <!-- Aktionsende – deaktiviert bis Aktionsstart gesetzt ist -->
    <phscw-input-date
        formControlName="event_end_date"
        [editMode]="editMode"
        [disabled]="editMode && !hasStartDate"
        name="event_end_date"
        inputId="event_end_date"
        label="Aktionsende"
        [required]="false"
        [matTooltip]="editMode && !hasStartDate ? 'Bitte zuerst den Aktionsstart eingeben' : ''">
    </phscw-input-date>

    <!-- Produkt (Event-Kennzeichen) -->
    <phscw-input-text
        [editMode]="editMode"
        label="Produkt"
        name="brand"
        inputId="brand"
        formControlName="brand">
    </phscw-input-text>

    <!-- Kostenart Plan – muss vor dem Betrag ausgefüllt werden -->
    <phscw-input-select
        [editMode]="editMode"
        label="Kostenart Plan-Kosten"
        name="event_cost_type_plan"
        inputId="event_cost_type_plan"
        formControlName="event_cost_type_plan"
        listentries="eventCostType"
        [getListData]="true"
        [matTooltip]="editMode ? 'Kostenart und Betrag müssen gemeinsam angegeben werden' : ''">
    </phscw-input-select>

    <!-- Plan-Kosten – deaktiviert bis Kostenart gesetzt ist -->
    <phscw-input-number
        [editMode]="editMode"
        [disabled]="editMode && !hasCostTypePlan"
        label="Plan-Kosten"
        name="cost_plan"
        inputId="cost_plan"
        formControlName="cost_plan"
        valueType="currency"
        [matTooltip]="editMode && !hasCostTypePlan ? 'Bitte zuerst die Kostenart (Plan) auswählen' : ''">
    </phscw-input-number>

    @if (editMode && costPairErrors?.['planCostTypeMissing']) {
        <span class="cw-input-hint">Bitte eine Kostenart für die Plan-Kosten auswählen.</span>
    }
    @if (editMode && costPairErrors?.['planCostMissing']) {
        <span class="cw-input-hint">Bitte einen Betrag für die Plan-Kosten eingeben.</span>
    }

    <!-- Kostenart Ist – muss vor dem Betrag ausgefüllt werden -->
    <phscw-input-select
        [editMode]="editMode"
        label="Kostenart Ist-Kosten"
        name="event_cost_type_actual"
        inputId="event_cost_type_actual"
        formControlName="event_cost_type_actual"
        listentries="eventCostType"
        [getListData]="true"
        [matTooltip]="editMode ? 'Kostenart und Betrag müssen gemeinsam angegeben werden' : ''">
    </phscw-input-select>

    <!-- Ist-Kosten – deaktiviert bis Kostenart gesetzt ist -->
    <phscw-input-number
        [editMode]="editMode"
        [disabled]="editMode && !hasCostTypeActual"
        label="Ist-Kosten"
        name="cost_actual"
        inputId="cost_actual"
        formControlName="cost_actual"
        valueType="currency"
        [matTooltip]="editMode && !hasCostTypeActual ? 'Bitte zuerst die Kostenart (Ist) auswählen' : ''">
    </phscw-input-number>

    @if (editMode && costPairErrors?.['actualCostTypeMissing']) {
        <span class="cw-input-hint">Bitte eine Kostenart für die Ist-Kosten auswählen.</span>
    }
    @if (editMode && costPairErrors?.['actualCostMissing']) {
        <span class="cw-input-hint">Bitte einen Betrag für die Ist-Kosten eingeben.</span>
    }

    <!-- Notiz -->
    <phscw-input-textarea
        [editMode]="editMode"
        label="Notiz"
        name="event_notes"
        inputId="event_notes"
        formControlName="event_notes">
    </phscw-input-textarea>
</form>

<!-- Budgetzuordnung -->
<form class="cw-submodule" #budgetForm="ngForm">
    <div class="cw-flex-row">
        <h3>Budgetzuordnung</h3>
        @if (editMode && budgetAssignments.length === 0) {
            <span class="icon-plus cw-toolbar-icon" style="margin-left: auto" (click)="addBudgetAssignment()"></span>
        }
    </div>
    <div class="cw-horizontalline"></div>

    @if (budgetAssignments[0]) {
        <!-- Gebiet – schaltet Budgetart frei -->
        <phscw-input-select
            [editMode]="editMode"
            label="Gebiet"
            name="budget_region"
            [ngModel]="budgetAssignments[0].region_id"
            (ngModelChange)="onBudgetRegionChange($event)"
            [selectData]="selectBudgetRegions">
        </phscw-input-select>

        <!-- Budgetart – nur die Budgetarten, für die es beim gewählten Gebiet ein Budget gibt -->
        <phscw-input-select
            [editMode]="editMode"
            [disabled]="editMode && !hasBudgetRegion"
            label="Budgetart"
            name="budget_type"
            [(ngModel)]="budgetAssignments[0].budget_type"
            [selectData]="selectBudgetTypes"
            [matTooltip]="editMode && !hasBudgetRegion ? 'Bitte zuerst ein Gebiet auswählen' : ''">
        </phscw-input-select>
        @if (editMode && hasBudgetRegion && !budgetAssignments[0].budget_type) {
            <span class="cw-input-hint">Bitte eine Budgetart für das gewählte Gebiet auswählen.</span>
        }
    }
</form>

@if (editMode) {
    <div class="cw-button-wrapper">
        <button mat-raised-button color="accent" type="submit" (click)="onSubmit()"
            [disabled]="eventForm.invalid || (hasBudgetRegion && !budgetAssignments[0]?.budget_type)">
            {{ 'GENERAL.SAVE' | translate }}
        </button>
        <button mat-raised-button color="primary" type="button" (click)="onCancel()">
            {{ 'GENERAL.CANCEL' | translate }}
        </button>
    </div>
}
@if (!editMode) {
    <div class="cw-button-wrapper">
        <button mat-raised-button color="primary" type="button" (click)="onCancel()">
            {{ 'GENERAL.CANCEL' | translate }}
        </button>
    </div>
}
